import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_owners_and_projects_hub_ComponentContextService } from './FootprintManager.owners_and_projects_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_owners_navigation_gridComponent } from './FootprintManager.owners_navigation_grid.component';
import { FootprintManager_projects_gridComponent } from './FootprintManager.projects_grid.component';
import { Owners_owners_by_count_widgetComponent } from './Owners.owners_by_count_widget.component';
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_multiComponent } from './Owners.projects_dd_multi.component'
import { Owners_owner_project_statuses_dd_singleComponent } from './Owners.owner_project_statuses_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_owners_navigation_gridComponent),
    forwardRef(() => FootprintManager_projects_gridComponent),
    forwardRef(() => Owners_owners_by_count_widgetComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_multiComponent),
    forwardRef(() => Owners_owner_project_statuses_dd_singleComponent),
  ],
  selector: 'FootprintManager-owners_and_projects_hub',
  templateUrl: './FootprintManager.owners_and_projects_hub.component.html'
})
export class FootprintManager_owners_and_projects_hubComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { ownerStatusId?: number } = { };
  //#endregion
  formGroup: FormGroup = new FormGroup({
    owner: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      new_dropdown: new ToolModel(new SplitButtonModel<{ create_owner: ButtonModel, create_project: ButtonModel }>(
        'new_dropdown',
        new ButtonStyles(['creation'], null),
        false,
        false,
        'New',
        'icon-ic_fluent_add_20_regular',
        null,
        [
          new ButtonModel('create_owner', new ButtonStyles(null, null), false, false, false, 'Owner', ''),
          new ButtonModel('create_project', new ButtonStyles(null, null), false, false, false, 'Project', '')
        ])
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      import_projects: new ToolModel(new ButtonModel('import_projects', new ButtonStyles(null, null), false, false, false, 'Import projects', 'icon-ic_fluent_arrow_upload_20_regular', null)
    , false)
  };

  actionbar = {
  };

 filters = {
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Owner', false, false),
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Project', false, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
  };


  filtersets = {
    newGroup1: new FieldsetModel(
      'Filters',
      false,
      true,
      true,
      false,
        null
      ,
      () => {
        const $hub = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      owners: new TabItemModel(
        this.rootTabGroup, 
        'Owners', 
        false,
        ),
      projects: new TabItemModel(
        this.rootTabGroup, 
        'Projects', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    get $tabs_owners_owners_navigation_grid_inParams_ownerStatusId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.status.control.value;
      
      return expr;
    }
  
    get $tabs_owners_owners_navigation_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_owners_owners_navigation_grid_inParams_projectIds: number[];
    get $tabs_owners_owners_navigation_grid_inParams_projectIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_owners_owners_navigation_grid_inParams_projectIds, expr)) {
        this.cacheValueFor_$tabs_owners_owners_navigation_grid_inParams_projectIds = expr;
      }
      return this.cacheValueFor_$tabs_owners_owners_navigation_grid_inParams_projectIds;
    }
  
    get $tabs_projects_projects_grid_inParams_projectStatusId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.status.control.value;
      
      return expr;
    }
  
    get $tabs_projects_projects_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_projects_projects_grid_inParams_projectIds: number[];
    get $tabs_projects_projects_grid_inParams_projectIds(): number[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = $hub.filters.project.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_projects_projects_grid_inParams_projectIds, expr)) {
        this.cacheValueFor_$tabs_projects_projects_grid_inParams_projectIds = expr;
      }
      return this.cacheValueFor_$tabs_projects_projects_grid_inParams_projectIds;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_owners', { read: FootprintManager_owners_navigation_gridComponent }) $tabs_owners: FootprintManager_owners_navigation_gridComponent;
      @ViewChild('$tabs_projects', { read: FootprintManager_projects_gridComponent }) $tabs_projects: FootprintManager_projects_gridComponent;
    //#endregion tabs children
    widgets = {
      owners_count: new WidgetModel(false),
    };
  
    //#region widgets inParams
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_owners_count', { read:  Owners_owners_by_count_widgetComponent }) $widgets_owners_count: Owners_owners_by_count_widgetComponent;
    //#endregion widgets children

  //#region filters inParams
  get $fields_owner_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_owner_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  get $fields_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_project_selector_inParams_ownerId(): number {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.owner.control.value;
    
    return expr;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Owners and projects hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Manage inventory owners and their projects for different clients or entities.`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_owners_and_projects_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.owners,
      this.tabs.projects,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Owners and projects hub';
    
    const $hub = this;
    const $utils = this.$utils;

    (this.filters.status.control as SelectBoxModel).reset(1);

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['owner']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_change();
      });
    this.formGroup
      .controls['project']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_project_change();
      });
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_owners_count') {
      if (!isNil(this.$widgets_owners_count) && !this.widgets.owners_count.hidden) {
        this.$widgets_owners_count.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
    if (childToSkip !== '$tabs_owners') {
      if (!isNil(this.$tabs_owners) && !this.tabs.owners.hidden) {
        this.$tabs_owners.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_projects') {
      if (!isNil(this.$tabs_projects) && !this.tabs.projects.hidden) {
        this.$tabs_projects.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_create_owner_clicked(event = null) {
    return this.on_create_owner_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_owner_clickedInternal(
    $hub: FootprintManager_owners_and_projects_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owners_and_projects_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub.on_create_owner_clicked');
  
  
  const dialogResult = (await $shell.FootprintManager.openowner_creation_formDialog('flyout'));
  const userConfirmed = dialogResult.confirm;
  const ownerId = dialogResult.ownerId;
  if (userConfirmed) {
      $hub.refresh();
  
      if ($utils.isDefined(ownerId)) {
          $shell.FootprintManager.opensingle_owner_hub({ ownerId: ownerId});
  
      }
  
  }
  }
  on_import_projects_clicked(event = null) {
    return this.on_import_projects_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_import_projects_clickedInternal(
    $hub: FootprintManager_owners_and_projects_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owners_and_projects_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub.on_import_projects_clicked');
  
  
  $shell.ExcelProjectImport.openexcel_project_import_gridDialog('modal', EModalSize.Large);
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootprintManager_owners_and_projects_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owners_and_projects_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub.on_init');
  
  
  if (await $operations.FootprintManager.Disable_Navigation_Owners_Owners_Hub.isAuthorized()) {
      
      $hub.close();
      throw new Error ('This screen currently requires authorization, please see your system admin for access.')
    
  }
  
  
  $hub.toolbar.new_dropdown.control.buttons.create_owner.disabled = (await $operations.FootprintManager.Disable_Owner_Creation.isAuthorized());
  $hub.toolbar.new_dropdown.control.buttons.create_project.disabled = (await $operations.FootprintManager.Disable_Project_Creation.isAuthorized());
  $hub.toolbar.import_projects.hidden  = (await $operations.FootprintManager.Disable_Project_Importing.isAuthorized());
  
  
  
  }
  on_create_project_clicked(event = null) {
    return this.on_create_project_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_project_clickedInternal(
    $hub: FootprintManager_owners_and_projects_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owners_and_projects_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub.on_create_project_clicked');
  
  if ($utils.isDefined($hub.filters.owner.control.value)) {
      const dialogResult = (await $shell.FootprintManager.openproject_creation_formDialog({ ownerId: $hub.filters.owner.control.value }, 'flyout'));
      const userConfirmed = dialogResult.confirm;
      const projectId = dialogResult.projectId;
      if (userConfirmed) {
          $hub.refresh();
  
          if ($utils.isDefined(projectId)) {
              $shell.FootprintManager.opensingle_project_hub({ projectId: projectId });
  
          }
  
      }
  }
  
  else {
      throw new Error ('Please select an owner before creating a project.')
  }
  }
  on_owner_change(event = null) {
    return this.on_owner_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changeInternal(
    $hub: FootprintManager_owners_and_projects_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owners_and_projects_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub.on_owner_change');
  $hub.filters.project.control.value = null;
  
  $hub.filters.project.control.value = [];
  }
  on_project_change(event = null) {
    return this.on_project_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_changeInternal(
    $hub: FootprintManager_owners_and_projects_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owners_and_projects_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'owners_and_projects_hub.on_project_change');
  const projectId = $hub.filters.project.control.value
  
  
  // Set Owner from Project
  if ($utils.isDefined(projectId) && !$utils.isDefined($hub.filters.owner.control.value)) {
      const project = (await $datasources.Materials.ds_get_project_by_projectId.get({
          projectId: projectId
      })).result;
     
      if ($utils.isDefined(project)) {
  
          $hub.filters.owner.control.value = project[0].OwnerId;
  
      }
  
  }
  }
  //#endregion private flows
}
